<template>
  <div class="container">
    <div class="row" v-if="showData">
      <div
        class="pb-4 text-center"
        :class="{
          'col-sm': !isReport,
          col: isReport,
        }"
        v-for="(item, i) in reportKey"
        :key="i"
      >
        <div
          :class="{ lightBorderReport: isReport }"
          class="elevation-1 radius-20"
        >
          <div class="radius-20">
            <div class="card-title p-0" style="min-height: 0;">
              <span class="text-barlow-condensed subtitle text-dark">
                {{ item.title }}
              </span>
            </div>
            <div class="card-section py-0">
              <img
                style="height: 100px;"
                :src="require(`@/assets/images/habilities/${item.imgSrc}.png`)"
              />
            </div>
            <div class="card-section">
              <div
                class="row"
                v-for="(student, index) in reportData[item.key]"
                :key="index"
              >
                <div class="col">
                  {{ student.firstname1 }}
                  {{ student.lastname }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row" v-if="showSpinner">
      <div class="col text-center">
        <Spinner />
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Spinner from "@/components/Spinner";

export default {
  name: "students",
  components: {
    Spinner,
  },
  props: ["isReport", "monthlyReportData"],
  data() {
    return {
      showData: false,
      showSpinner: false,
      reportData: null,
      reportKey: [
        {
          title: this.$t("habilities.LOC"),
          imgSrc: "LOC",
          key: "masDescendidosLocalizar",
        },
        {
          title: this.$t("habilities.RV"),
          imgSrc: "RV",
          key: "masDescendidosReflexionar",
        },
        {
          title: this.$t("habilities.IN"),
          imgSrc: "IN",
          key: "masDescendidosIntegrar",
        },
      ],
    };
  },
  computed: {
    ...mapState(["dataUrl", "reports"]),
  },
  methods: {
    async getData() {
      if (!this.reports.dateFilterVal) return;

      let endpoint;
      this.showData = false;
      this.showSpinner = true;

      switch (this.reports.dateFilterVal) {
        case "1":
          endpoint = `/bookEvaluationCourse/getAllAssignedByCourseInCurrentMonth?courseId=${this.reports.course}`;
          break;
        case "2":
          endpoint = `/bookEvaluationCourse/getAllAssignedByCourseInLast30Days?courseId=${this.reports.course}`;
          break;
        case "3":
          if (this.reports.initialDate && this.reports.endDate) {
            endpoint = `/bookEvaluationCourse/getAllAssignedByCourseBetweenDates?courseId=${this.reports.course}&fromDate=${this.reports.initialDate}&toDate=${this.reports.endDate}`;
          } else {
            this.showSpinner = false;
            return;
          }
          break;
      }

      let apiUrl = `${this.dataUrl}${endpoint}`;

      try {
        let { data } = await this.axios.get(apiUrl);

        this.reportData = data.content;
        this.showData = true;
      } catch {
        this.$notify({
          title: ["Ocurrió un error"],
          type: "danger",
        });
      } finally {
        this.showSpinner = false;
      }
    },
  },
  mounted() {
    if (!this.isReport) this.getData();
  },
  created() {
    if (this.isReport) {
      this.reportData = this.monthlyReportData;
      this.showData = true;
    }
  },
};
</script>

<style lang="scss" scoped>
.card-title {
  min-height: 90px;
}
</style>
